"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var http_response_1 = require("./models/http-response");

var HttpHelperClass =
/** @class */
function () {
  function HttpHelperClass() {
    var _this = this;

    this.currentCalls = {};
    this.cancelTokens = {};
    /**
     * Check if instance has been created otherwise throw error
     */

    this.validateInstance = function () {
      (!_this.instance ? function () {
        throw new Error('Error!! Instance has not been created. Please call "createInstance" first');
      } : function () {})();
    };
    /**
     * Create instance with default configs
     * @param config default configs
     */


    this.createInstance = function (config) {
      _this.instance = axios_1.default.create(config);
    };
    /**
     * Return current instance
     */


    this.getInstance = function () {
      return _this.instance;
    };
    /**
     * Set call task to be used by saga in cancellation mechanism.
     *
     * @param id http request identifier
     * @param task saga task
     */


    this.setCallTask = function (id, task) {
      _this.currentCalls[id] = task;
    };
    /**
     * Get call task reference
     *
     * @param id http request identifier
     */


    this.getCallTask = function (id) {
      return _this.currentCalls[id];
    };
    /**
     * Delete call task reference after call completed or cancelled
     *
     * @param id http request identifier
     */


    this.deleteCallTask = function (id) {
      delete _this.currentCalls[id];
    };
    /**
     * Delete cancel token after the call is completed or cancelled
     *
     * @param id http request identifier
     */


    this.deleteCancelToken = function (id) {
      delete _this.cancelTokens[id];
    };
    /**
     * Cancel axios instance http call
     */


    this.cancel = function (id) {
      (_this.cancelTokens[id] ? function () {
        _this.cancelTokens[id].cancel();
      } : function () {})();

      _this.deleteCancelToken(id);
    };
    /**
     * Set http header that will be applied to all request coming from default instance.
     *
     * @param key http header key
     * @param value
     */


    this.setHeader = function (key, value) {
      var _a;

      _this.validateInstance();

      if (_this.instance) {
        Object.assign(_this.instance.defaults, {
          headers: __assign(__assign({}, _this.instance.defaults.headers), (_a = {}, _a[key] = value, _a))
        });
      }
    };
    /**
     * Fire http get request and catch error, no need to use try/catch when call this method
     *
     * @param param get request param
     */


    this.get = function (_a) {
      var url = _a.url,
          _b = _a.config,
          config = _b === void 0 ? {} : _b,
          id = _a.id;
      return __awaiter(_this, void 0, void 0, function () {
        var CancelToken_1, resp, error_1;

        var _this = this;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              this.validateInstance();
              _c.label = 1;

            case 1:
              _c.trys.push([1, 3,, 4]);

              CancelToken_1 = axios_1.default.CancelToken;
              (id ? function () {
                _this.cancelTokens[id] = CancelToken_1.source();
              } : function () {})();
              return [4
              /*yield*/
              , this.instance.get(url, __assign(__assign({}, config), {
                cancelToken: id ? this.cancelTokens[id].token : undefined
              }))];

            case 2:
              resp = _c.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(resp)];

            case 3:
              error_1 = _c.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(error_1)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * Fire http post request and catch error, no need to use try/catch when call this method
     *
     * @param param post request param
     */


    this.post = function (_a) {
      var url = _a.url,
          data = _a.data,
          config = _a.config,
          id = _a.id;
      return __awaiter(_this, void 0, void 0, function () {
        var CancelToken_2, resp, error_2;

        var _this = this;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.validateInstance();
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              CancelToken_2 = axios_1.default.CancelToken;
              (id ? function () {
                _this.cancelTokens[id] = CancelToken_2.source();
              } : function () {})();
              return [4
              /*yield*/
              , this.instance.post(url, data, __assign(__assign({}, config), {
                cancelToken: id ? this.cancelTokens[id].token : undefined
              }))];

            case 2:
              resp = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(resp)];

            case 3:
              error_2 = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(error_2)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * Fire http delete request and catch error, no need to use try/catch when call this method
     *
     * @param param delete request param
     */


    this.delete = function (_a) {
      var url = _a.url,
          config = _a.config,
          id = _a.id;
      return __awaiter(_this, void 0, void 0, function () {
        var CancelToken_3, resp, error_3;

        var _this = this;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.validateInstance();
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              CancelToken_3 = axios_1.default.CancelToken;
              (id ? function () {
                _this.cancelTokens[id] = CancelToken_3.source();
              } : function () {})();
              return [4
              /*yield*/
              , this.instance.delete(url, __assign(__assign({}, config), {
                cancelToken: id ? this.cancelTokens[id].token : undefined
              }))];

            case 2:
              resp = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(resp)];

            case 3:
              error_3 = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(error_3)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * Fire http patch request and catch error, no need to use try/catch when call this method
     *
     * @param param patch request param
     */


    this.patch = function (_a) {
      var url = _a.url,
          data = _a.data,
          config = _a.config,
          id = _a.id;
      return __awaiter(_this, void 0, void 0, function () {
        var CancelToken_4, resp, error_4;

        var _this = this;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.validateInstance();
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              CancelToken_4 = axios_1.default.CancelToken;
              (id ? function () {
                _this.cancelTokens[id] = CancelToken_4.source();
              } : function () {})();
              return [4
              /*yield*/
              , this.instance.patch(url, data, __assign(__assign({}, config), {
                cancelToken: id ? this.cancelTokens[id].token : undefined
              }))];

            case 2:
              resp = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(resp)];

            case 3:
              error_4 = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(error_4)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * Fire http patch request and catch error, no need to use try/catch when call this method
     *
     * @param param patch request param
     */


    this.put = function (_a) {
      var url = _a.url,
          data = _a.data,
          config = _a.config,
          id = _a.id;
      return __awaiter(_this, void 0, void 0, function () {
        var CancelToken_5, resp, error_5;

        var _this = this;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              this.validateInstance();
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              CancelToken_5 = axios_1.default.CancelToken;
              (id ? function () {
                _this.cancelTokens[id] = CancelToken_5.source();
              } : function () {})();
              return [4
              /*yield*/
              , this.instance.put(url, data, __assign(__assign({}, config), {
                cancelToken: id ? this.cancelTokens[id].token : undefined
              }))];

            case 2:
              resp = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(resp)];

            case 3:
              error_5 = _b.sent();
              return [2
              /*return*/
              , new http_response_1.HttpResponse(error_5)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
  }

  return HttpHelperClass;
}();

exports.HttpHelper = new HttpHelperClass();